// extracted by mini-css-extract-plugin
export default {"zoomModal":"V2-z","image":"W2-z","button":"X2-z","isOverlayShown":"Y2-z"};